import { withInstall } from '@hd-front-end/utils'
import Col from './src/col.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCol: SFCWithInstall<typeof Col> = withInstall(Col)
export default ElCol

export * from './src/col'
